$(document).ready(function(){
    //activa el acordeon con click
    $(".categorie_title").on("click", function(){
        $(this).toggleClass("title_active")
        let cont = $(this).siblings(".categorie_content")[0];
        $(cont).toggleClass("active")
    })

    //drawer en mobile
    $("button.filtros").on("click", function(){
        $("#filtro").toggleClass("on")
    })
})